import { SplitTestSettingsWorkflow } from '../SplitTestSettings/SplitTestSettingsWorkflow';
import { DisplayWebContent } from './components/DisplayWebContent';
import { useIsSplitTestSelector } from '../../../state/SplitTests/selectors/useIsSplitTestSelector';

export function DisplayWebContentWorkflow({ id }) {
  const isSplitTest = useIsSplitTestSelector(id);

  return isSplitTest ? <SplitTestSettingsWorkflow id={id} /> : <DisplayWebContent id={id} />;
}
